import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/auth.service';

@Component({
    selector: 'app-personal-dialog',
    templateUrl: './personal-dialog.component.html',
    styleUrls: ['./personal-dialog.component.scss'],
    standalone: false
})
export class PersonalDialogComponent implements OnInit {

  constructor(private authService: AuthService) { }

  text: string = "To avoid any delays in the background check process please ensure personal details match those on your legal identification";

  ngOnInit(): void {
    let jobSubCountry = this.authService.getJobSubCountry();

    if (this.authService.getJobCountry() === "IND" && jobSubCountry === "GBS") {
      this.text = "To avoid delays in the background check process please ensure your name matches exactly to your Aadhaar & PAN card, including Middle Name.";
    }
  }
}
